module.exports = {
  path: '/team_basic',
  name: 'team',
  meta: { title: '比赛管理', icon: 'el-icon-upload' },
  component: () => import('../views/team/team.vue') //子分类挂载过度,
}
